import React from 'react';
import { css, Global } from '@emotion/react';
import { theme } from '../../../../../domain/theme';
import { t } from '../../../../../domain/services/configService';
import { IconHamburger } from '../../../../Icon/IconHamburger';
import { HamburgerMenu } from '../../HamburgerMenu';
import { IconClose } from '../../../../Icon/IconClose';

const styles = {
  hamburgerIcon: css`
    height: 50px;
    padding: ${theme.spacing.parse('0 $xs')};
    display: grid;
    border-left: 1px solid #f2f2f2;
    place-items: center;
    line-height: initial;
    ${theme.mq.tablet} {
      padding: ${theme.spacing.parse('0 $s')};
    }
    > label {
      max-height: 18px;
    }
    svg {
      cursor: pointer;
    }
  `,
  closeHamburgerIcon: css`
    position: absolute;
    top: 2rem;
    right: 2rem;
    width: 24px;
    height: 24px;
    z-index: 999;
    svg {
      cursor: pointer;
    }
  `,
  hidden: css`
    display: none;
  `,
  menuModalToggle: css`
    &:checked ~ .modal-menu {
      display: block;
      z-index: 999;
    }
  `,
  menuModal: css`
    display: none;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    overflow-y: auto;
    background-color: #000;
    z-index: -999;
  `
};

export const HamburgerMenuItem = () => {
  return (
    <>
      <Global
        styles={css`
          body:has(input[type='checkbox']#menu-toggle:checked) {
            overflow: hidden;
            #main-navigation-nav[data-is-sticky='true'] {
              transition: none;
              transform: unset;
            }
          }
        `}
      />

      <div css={styles.hamburgerIcon} title="Menu">
        <label htmlFor="menu-toggle">
          <span css={styles.hidden}>Menu</span>
          <IconHamburger size={18} />
        </label>
      </div>

      <input
        type="checkbox"
        css={[styles.menuModalToggle, styles.hidden]}
        id="menu-toggle"
      />

      <div css={styles.menuModal} className="modal-menu">
        <HamburgerMenu />

        <div css={styles.closeHamburgerIcon} title={t('close')}>
          <label htmlFor="menu-toggle">
            <span css={styles.hidden}>{t('close')}</span>
            <IconClose color="#fff" />
          </label>
        </div>
      </div>
    </>
  );
};
